import React, { useState } from "react";
import styles from './videoCallPage.module.css';
//import Grid from '@mui/material/Grid';
import Grid from '@mui/material/Unstable_Grid2';
import VideoCallChat from "./VideoCallChat";
import VideoCallArea from "./VideoCallArea";

import { FaStar } from "react-icons/fa";
import { IoExit } from "react-icons/io5";

import { BsFillChatFill } from "react-icons/bs";
import { IoVideocam } from "react-icons/io5";
import { BsMicMuteFill } from "react-icons/bs";
import { BsMicFill } from "react-icons/bs";

function VideoCallPage(props) {
  const [showChat, setShowChat] = useState(false);
  //const [msgs, setMsgs] = useState([]);        // Realised again this is not needed if we are using '0' instead of 'null' for videoCallChat rendering in xs={} thing. Creating this state here because if you create this in 'VideoCallChat.jsx' it will disappear because of component re-rendering when {styles.show_chat_buttton' is pressed.
  //const [newMsg, setNewMsg] = useState('');    // Realised again this is not needed if we are using '0' instead of 'null' for videoCallChat rendering in xs={} thing. Creating this state here because if you create this in 'VideoCallChat.jsx' it will disappear because of component re-rendering when {styles.show_chat_buttton' is pressed.

  async function showChatToggle(){
    try {
      setShowChat((prevValue) => {
        return ((prevValue === false) ? true : false);
      });
    } catch (error) {
      console.log(error);
    }
  }

  return (
    <div className={styles.main_div}>
      <div className={styles.header_div}>
        <FaStar />
        <h1 className={styles.header}>Discusslearn</h1>
        <IoExit />
      </div>
      {/*---------------------------------*/}
      <div className={styles.vid_outer_div}>
        <Grid container spacing={0} className={styles.main_grid}>
          <VideoCallArea show_chat_vca={showChat}/>    {/*This is a grid.*/}         
          <VideoCallChat show_chat_vcc={showChat}/>    {/*This is a grid.*/}
        </Grid>
      </div>
      {/*---------------------------------*/}
      <div className={styles.footer_div}>
        <IoVideocam />
        <BsMicMuteFill />
        <BsMicFill />
        <button className={styles.show_chat_buttton} onClick={showChatToggle}>
          <BsFillChatFill className={styles.chat_toggle_icon}/>
          <p className={styles.chat_word}>Chat</p>
        </button>
      </div> 
    </div>
  );
}

export default VideoCallPage;

